var map = {
	"./1_round.svg": 1017,
	"./224用户.svg": 1018,
	"./242锁定.svg": 1019,
	"./2_round.svg": 1020,
	"./3_round.svg": 1021,
	"./404.svg": 1022,
	"./4_round.svg": 1023,
	"./cancellation.svg": 1024,
	"./data.svg": 1025,
	"./game.svg": 1026,
	"./language.svg": 1027,
	"./qq.svg": 1028,
	"./security.svg": 1029,
	"./wechat.svg": 1030,
	"./weibo.svg": 1031,
	"./weixin.svg": 1032,
	"./键盘.svg": 1033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1016;